// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","navbar":"App_navbar__gqftH","content":"App_content__wwONY","extraMargin":"App_extraMargin__vfKGa"};